/* eslint-disable consistent-return */
import "./index.scss";
import "../../locales/i18n";

//import * as moment from "moment-timezone";
import React, { useEffect,useRef, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { useTranslation } from "react-i18next";
import OneSignal from "react-onesignal";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { TEXTKIT_NOTIFICATION_SOUND } from "src/constants/featureFlags";

import { TDropdownOption } from "@/components/components/Dropdown/dropdown.type";
import Switch from "@/components/components/Switch";
import { SwitchValue } from "@/components/components/Switch/switch.type";
import { getSavedContext } from "@/messenger/App";
import { representativeSettingsSelectors } from "@/messenger/ducks/entities/representativeSettings";
import { TRepresentative } from "@/messenger/types/entities/representative";

import { getBranchesHandler, getBranchNames } from "../helper";

export interface TUserMetadata {
    timezone: string;
    branch: Array<any>;
    wasFirstLoggedIn: boolean;
    notification: boolean;
    teamConversationCount: boolean;
}

export enum TSettingsPages {
    termsAndConditions = "termsAndConditions",
    timezones = "timezones",
    userSettings = "userSettings",
    branchSelector = "branchSelector",
    initialize = "initialize",
    profile = "profile",
    notifications = "notifications",
}

interface TSettingsProps {
    updateMetadata?: (m: any) => void;
    userMetadata?: TUserMetadata;
    initialCurrentPage?: TSettingsPages;
}

const RudderstackLogo = (<svg width="100" aria-Label="Rudderstack" style={{marginBottom:"6px"}} viewBox="0 0 153 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M150.224 0.761939H149.77V0.436035H151.123V0.761939H150.672V1.85071H150.225V0.761939H150.224Z" fill="#17176E"/>
<path d="M152.563 1.37383C152.563 1.14954 152.568 0.877348 152.577 0.711856H152.573C152.507 0.985499 152.419 1.3506 152.282 1.85071H151.914C151.806 1.38544 151.716 0.994935 151.649 0.708953H151.646C151.654 0.873719 151.67 1.14664 151.67 1.38979V1.85071H151.27V0.436035H151.91C151.999 0.754681 152.086 1.10236 152.125 1.34044H152.128C152.181 1.09002 152.268 0.759762 152.361 0.436035H152.999V1.85071H152.563V1.37383H152.563Z" fill="#17176E"/>
<path d="M26.0264 4.51541H30.1718V6.83738H30.2954C30.7281 5.11931 31.7186 4.35645 32.9872 4.35645C33.3585 4.35645 33.7299 4.42032 34.0702 4.52339V8.26875C33.6445 8.11777 32.9336 8.04591 32.4923 8.04591C31.2315 8.04591 30.2961 8.96846 30.2961 10.3679V16.7299H26.0264V4.51541Z" fill="#17176E"/>
<path d="M42.8395 4.51562H47.1092V16.7301H43.0563V14.4082H42.9327C42.4145 15.9665 41.0534 16.8891 39.2822 16.8891C36.7837 16.8891 35.1445 14.9808 35.1367 12.3083V4.51562H39.4064V11.3865C39.4142 12.595 40.0326 13.3266 41.1078 13.3266C42.1674 13.3266 42.848 12.595 42.8402 11.3865V4.51562H42.8395Z" fill="#17176E"/>
<path d="M48.5776 10.6226C48.5776 6.20148 50.8671 4.35639 53.2187 4.35639C54.9822 4.35639 56.0962 5.40596 56.56 6.64642H56.6221V0.443359H60.8918V16.7299H56.6532V14.7258H56.5607C56.0658 15.9663 54.9207 16.8888 53.2504 16.8888C50.7118 16.8888 48.5776 14.8528 48.5776 10.6226ZM56.7139 10.6226C56.7139 8.80944 56.0023 7.72793 54.8269 7.72793C53.6514 7.72793 52.9709 8.80944 52.9709 10.6226C52.9709 12.4358 53.6514 13.5173 54.8269 13.5173C56.0023 13.5173 56.7139 12.4038 56.7139 10.6226Z" fill="#17176E"/>
<path d="M62.2974 10.6226C62.2974 6.20148 64.5868 4.35639 66.9384 4.35639C68.7019 4.35639 69.8159 5.40596 70.2797 6.64642H70.3419V0.443359H74.6116V16.7299H70.3729V14.7258H70.2805C69.7856 15.9663 68.6405 16.8888 66.9702 16.8888C64.4315 16.8888 62.2974 14.8528 62.2974 10.6226ZM70.4336 10.6226C70.4336 8.80944 69.722 7.72793 68.5466 7.72793C67.3712 7.72793 66.6906 8.80944 66.6906 10.6226C66.6906 12.4358 67.3712 13.5173 68.5466 13.5173C69.722 13.5173 70.4336 12.4038 70.4336 10.6226Z" fill="#17176E"/>
<path d="M75.9551 10.6546C75.9551 6.86932 78.3067 4.35645 81.9883 4.35645C85.5767 4.35645 87.8972 6.73431 87.8972 10.6227V11.6403H80.1626V11.8312C80.1626 13.0078 80.9053 13.8672 82.1739 13.8672C83.0479 13.8672 83.7518 13.4774 83.9996 12.7857H87.8979C87.4955 15.3305 85.3762 16.9527 82.0815 16.9527C78.2756 16.9527 75.9551 14.6068 75.9551 10.6546ZM83.9678 9.22323C83.9445 8.17366 83.1404 7.44201 82.0808 7.44201C81.0366 7.44201 80.1859 8.16568 80.1626 9.22323H83.9678Z" fill="#17176E"/>
<path d="M89.3037 4.51541H93.4492V6.83738H93.5727C94.0055 5.11931 94.9959 4.35645 96.2646 4.35645C96.6359 4.35645 97.0072 4.42032 97.3475 4.52339V8.26875C96.9218 8.11777 96.2109 8.04591 95.7697 8.04591C94.5088 8.04591 93.5734 8.96846 93.5734 10.3679V16.7299H89.3037V4.51541Z" fill="#17176E"/>
<path d="M105.692 7.87873C105.421 7.05998 104.756 6.2405 103.318 6.2405C102.003 6.2405 101.013 6.90828 101.02 7.84679C101.013 8.67353 101.577 9.12718 102.884 9.4451L104.771 9.89077C106.953 10.4076 108.019 11.4731 108.019 13.1992C108.019 15.4101 106.031 16.9765 103.162 16.9765C100.494 16.9765 98.7458 15.7599 98.3589 13.5969L100.594 13.2471C100.872 14.4476 101.762 15.0602 103.146 15.0602C104.662 15.0602 105.644 14.3206 105.644 13.3741C105.644 12.6105 105.111 12.0857 103.966 11.8237L101.955 11.3708C99.7277 10.862 98.7069 9.70858 98.7069 7.97527C98.7069 5.81225 100.61 4.35693 103.294 4.35693C105.861 4.35693 107.308 5.5974 107.787 7.49839L105.692 7.87873Z" fill="#17176E"/>
<path d="M115.776 6.42372H113.34V13.1436C113.34 14.5191 114.013 14.7738 114.763 14.7738C115.134 14.7738 115.42 14.702 115.575 14.6708L115.993 16.6349C115.722 16.738 115.227 16.8817 114.493 16.8897C112.667 16.9296 111.02 15.8561 111.028 13.6372V6.42372H109.288V4.51547H111.028V1.58887H113.341V4.51547H115.777V6.42372H115.776Z" fill="#17176E"/>
<path d="M117.445 13.2783C117.445 10.5026 119.75 9.89874 122 9.628C124.135 9.37323 125.001 9.3892 125.001 8.52254V8.46665C125.001 7.08319 124.236 6.27968 122.743 6.27968C121.189 6.27968 120.322 7.1144 119.982 7.98179L117.808 7.47297C118.582 5.24608 120.562 4.35547 122.712 4.35547C124.599 4.35547 127.322 5.06317 127.322 8.61763V16.7289H125.064V15.0588H124.971C124.53 15.9733 123.424 16.999 121.46 16.999C119.201 16.9997 117.445 15.6801 117.445 13.2783ZM125.009 12.3238V10.7494C124.677 11.0913 122.898 11.2982 122.147 11.4012C120.809 11.5842 119.711 12.0371 119.711 13.3095C119.711 14.4861 120.655 15.0907 121.962 15.0907C123.887 15.0914 125.009 13.7711 125.009 12.3238Z" fill="#17176E"/>
<path d="M129.54 10.6776C129.54 6.94818 131.706 4.35547 135.054 4.35547C137.754 4.35547 139.71 5.9937 139.958 8.45867H137.707C137.46 7.31328 136.563 6.35953 135.093 6.35953C133.16 6.35953 131.875 8.00574 131.875 10.6217C131.875 13.2855 133.136 14.9637 135.093 14.9637C136.415 14.9637 137.414 14.1841 137.707 12.8645H139.958C139.702 15.2424 137.885 16.9757 135.078 16.9757C131.628 16.9764 129.54 14.3598 129.54 10.6776Z" fill="#17176E"/>
<path d="M142.116 0.443359H144.428V9.68408H144.63L149.363 4.51535H152.132L147.321 9.75594L152.457 16.7299H149.618L145.581 11.2113L144.428 12.3958V16.7299H142.116V0.443359Z" fill="#17176E"/>
<path d="M12.6373 8.66217V4.33105H8.4248C8.4248 6.72271 10.3104 8.66217 12.6373 8.66217Z" fill="#17176E"/>
<path d="M0 16.7299H6.23298C9.76988 16.7299 12.6375 13.7815 12.6375 10.145H0V16.7299Z" fill="#17176E"/>
<path d="M8.4248 0C8.4248 2.39166 10.3104 4.33111 12.6373 4.33111V0H8.4248Z" fill="#17176E"/>
<path d="M4.2124 0C4.2124 2.39166 6.09804 4.33111 8.42491 4.33111H4.2124C4.2124 6.72277 6.09804 8.66223 8.42491 8.66223V4.33111V0H4.2124Z" fill="#17176E"/>
<path d="M4.21251 8.66217V4.33105H0C0 6.72271 1.88564 8.66217 4.21251 8.66217Z" fill="#17176E"/>
</svg>);

const awsLogo = (<svg width="22" style={{marginRight: "8px"}} enableBackground="new 0 0 304 182" version="1.1" viewBox="0 0 304 182">
<path fill="#252F3E" d="m86.4 66.4c0 3.7 0.4 6.7 1.1 8.9 0.8 2.2 1.8 4.6 3.2 7.2 0.5 0.8 0.7 1.6 0.7 2.3 0 1-0.6 2-1.9 3l-6.3 4.2c-0.9 0.6-1.8 0.9-2.6 0.9-1 0-2-0.5-3-1.4-1.4-1.5-2.6-3.1-3.6-4.7-1-1.7-2-3.6-3.1-5.9-7.8 9.2-17.6 13.8-29.4 13.8-8.4 0-15.1-2.4-20-7.2s-7.4-11.2-7.4-19.2c0-8.5 3-15.4 9.1-20.6s14.2-7.8 24.5-7.8c3.4 0 6.9 0.3 10.6 0.8s7.5 1.3 11.5 2.2v-7.3c0-7.6-1.6-12.9-4.7-16-3.2-3.1-8.6-4.6-16.3-4.6-3.5 0-7.1 0.4-10.8 1.3s-7.3 2-10.8 3.4c-1.6 0.7-2.8 1.1-3.5 1.3s-1.2 0.3-1.6 0.3c-1.4 0-2.1-1-2.1-3.1v-4.9c0-1.6 0.2-2.8 0.7-3.5s1.4-1.4 2.8-2.1c3.5-1.8 7.7-3.3 12.6-4.5 4.9-1.3 10.1-1.9 15.6-1.9 11.9 0 20.6 2.7 26.2 8.1 5.5 5.4 8.3 13.6 8.3 24.6v32.4zm-40.6 15.2c3.3 0 6.7-0.6 10.3-1.8s6.8-3.4 9.5-6.4c1.6-1.9 2.8-4 3.4-6.4s1-5.3 1-8.7v-4.2c-2.9-0.7-6-1.3-9.2-1.7s-6.3-0.6-9.4-0.6c-6.7 0-11.6 1.3-14.9 4s-4.9 6.5-4.9 11.5c0 4.7 1.2 8.2 3.7 10.6 2.4 2.5 5.9 3.7 10.5 3.7zm80.3 10.8c-1.8 0-3-0.3-3.8-1-0.8-0.6-1.5-2-2.1-3.9l-23.5-77.3c-0.6-2-0.9-3.3-0.9-4 0-1.6 0.8-2.5 2.4-2.5h9.8c1.9 0 3.2 0.3 3.9 1 0.8 0.6 1.4 2 2 3.9l16.8 66.2 15.6-66.2c0.5-2 1.1-3.3 1.9-3.9s2.2-1 4-1h8c1.9 0 3.2 0.3 4 1 0.8 0.6 1.5 2 1.9 3.9l15.8 67 17.3-67c0.6-2 1.3-3.3 2-3.9 0.8-0.6 2.1-1 3.9-1h9.3c1.6 0 2.5 0.8 2.5 2.5 0 0.5-0.1 1-0.2 1.6s-0.3 1.4-0.7 2.5l-24.1 77.3c-0.6 2-1.3 3.3-2.1 3.9s-2.1 1-3.8 1h-8.6c-1.9 0-3.2-0.3-4-1s-1.5-2-1.9-4l-15.5-64.5-15.4 64.4c-0.5 2-1.1 3.3-1.9 4s-2.2 1-4 1h-8.6zm128.5 2.7c-5.2 0-10.4-0.6-15.4-1.8s-8.9-2.5-11.5-4c-1.6-0.9-2.7-1.9-3.1-2.8s-0.6-1.9-0.6-2.8v-5.1c0-2.1 0.8-3.1 2.3-3.1 0.6 0 1.2 0.1 1.8 0.3s1.5 0.6 2.5 1c3.4 1.5 7.1 2.7 11 3.5 4 0.8 7.9 1.2 11.9 1.2 6.3 0 11.2-1.1 14.6-3.3s5.2-5.4 5.2-9.5c0-2.8-0.9-5.1-2.7-7s-5.2-3.6-10.1-5.2l-14.5-4.5c-7.3-2.3-12.7-5.7-16-10.2-3.3-4.4-5-9.3-5-14.5 0-4.2 0.9-7.9 2.7-11.1s4.2-6 7.2-8.2c3-2.3 6.4-4 10.4-5.2s8.2-1.7 12.6-1.7c2.2 0 4.5 0.1 6.7 0.4 2.3 0.3 4.4 0.7 6.5 1.1 2 0.5 3.9 1 5.7 1.6s3.2 1.2 4.2 1.8c1.4 0.8 2.4 1.6 3 2.5 0.6 0.8 0.9 1.9 0.9 3.3v4.7c0 2.1-0.8 3.2-2.3 3.2-0.8 0-2.1-0.4-3.8-1.2-5.7-2.6-12.1-3.9-19.2-3.9-5.7 0-10.2 0.9-13.3 2.8s-4.7 4.8-4.7 8.9c0 2.8 1 5.2 3 7.1s5.7 3.8 11 5.5l14.2 4.5c7.2 2.3 12.4 5.5 15.5 9.6s4.6 8.8 4.6 14c0 4.3-0.9 8.2-2.6 11.6-1.8 3.4-4.2 6.4-7.3 8.8-3.1 2.5-6.8 4.3-11.1 5.6-4.5 1.4-9.2 2.1-14.3 2.1z"/>
    <path fillRule="evenodd" clipRule="evenodd" fill="#FF9900" d="m273.5 143.7c-32.9 24.3-80.7 37.2-121.8 37.2-57.6 0-109.5-21.3-148.7-56.7-3.1-2.8-0.3-6.6 3.4-4.4 42.4 24.6 94.7 39.5 148.8 39.5 36.5 0 76.6-7.6 113.5-23.2 5.5-2.5 10.2 3.6 4.8 7.6z"/>
    <path fillRule="evenodd" clipRule="evenodd" fill="#FF9900" d="m287.2 128.1c-4.2-5.4-27.8-2.6-38.5-1.3-3.2 0.4-3.7-2.4-0.8-4.5 18.8-13.2 49.7-9.4 53.3-5 3.6 4.5-1 35.4-18.6 50.2-2.7 2.3-5.3 1.1-4.1-1.9 4-9.9 12.9-32.2 8.7-37.5z"/>
</svg>);

const OneSignalLogo = (<svg width="90" height="25" aria-Label="OneSignal" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 220"><path fill="#e54b4d" d="M504.8,440.33c19.83,0,28.58-10.64,28.58-22.93,0-27.48-43-18.95-43-32.79,0-5.43,4.88-9.2,12.41-9.2a30.13,30.13,0,0,1,21.49,8.53l7.31-9.64c-6.76-6.64-16.18-10.41-27.58-10.41-16.29,0-26.92,9.42-26.92,21.71,0,27.14,43,17.51,43,33,0,5-4.1,10.2-14.74,10.2A31.74,31.74,0,0,1,482,418.5l-7.31,10.08C481.32,435.45,491.17,440.33,504.8,440.33Zm46-61.37a7.21,7.21,0,1,0-7.2-7.2A7.19,7.19,0,0,0,550.77,379Zm5.77,60V385.49H544.9V439Zm36.88,21.71c-9.08,0-15.84-2-22.48-8l5.42-8.41c4.43,5,10,6.86,17.06,6.86,7.65,0,15.84-3.54,15.84-14.95v-6.09a21.52,21.52,0,0,1-17.17,9c-13.62,0-23.7-9.86-23.7-27.47,0-17.4,9.86-27.48,23.7-27.48a21,21,0,0,1,17.17,8.75v-7.42h11.63v50.74C620.89,455.5,606.49,460.71,593.42,460.71Zm2.11-32a17.75,17.75,0,0,0,13.73-7.09V401.55a17.75,17.75,0,0,0-13.73-7.09c-9.31,0-15.18,6.87-15.18,17.18S586.22,428.7,595.53,428.7ZM683.82,439V401.33c0-11-5.77-17.17-17.29-17.17a25.53,25.53,0,0,0-18.94,8.53v-7.2H636V439h11.63V401.55c2.77-3.54,7.87-7.08,13.74-7.08,6.54,0,10.85,2.65,10.85,11.07V439Zm59.48,0H731.67v-5.87c-4,4.65-10.3,7.2-17.39,7.2-8.64,0-18.5-6-18.5-17.73,0-12.4,9.75-17.5,18.5-17.5,7.31,0,13.4,2.33,17.39,6.87v-8c0-6.2-5.2-10-12.51-10a21.4,21.4,0,0,0-15.84,6.87l-4.88-8.09c6.2-6,14-8.64,22.49-8.64,12,0,22.37,5,22.37,19.28Zm-24.37-6.65c5,0,10-1.88,12.74-5.54v-8.2c-2.77-3.65-7.75-5.54-12.74-5.54-6.53,0-11.52,3.88-11.52,9.64S712.4,432.35,718.93,432.35ZM770,439V365.11H758.37V439Z" transform="translate(0 -290)"/><path fill="#e54b4d" d="M301.35,440.33c-21.82,0-36.66-16.4-36.66-38.22s14.84-38.22,36.66-38.22,36.78,16.4,36.78,38.22S323.18,440.33,301.35,440.33Zm0-8.2c16.5,0,27.25-12.85,27.25-30s-10.75-30-27.25-30-27.15,12.74-27.15,30S284.74,432.13,301.36,432.13ZM394,439V401.44c0-11.63-5.88-17.28-16.95-17.28a26.17,26.17,0,0,0-19.17,9.09v-7.76h-8.31V439h8.31V399.89c3.21-4.32,9.31-8.31,15.84-8.31,7.2,0,12.08,2.89,12.08,12.41v35Zm38.47,1.33c-16,0-27.37-11.41-27.37-28.14,0-15.51,11.08-28,26.37-28,16.17,0,25.7,12.63,25.7,28.69V415H414c.66,10.08,7.64,18.5,19.16,18.5a23.31,23.31,0,0,0,16.62-6.87l4,5.43C448.31,437.34,441.11,440.33,432.47,440.33ZM449,408.75c-.11-7.86-5.43-17.72-17.61-17.72-11.41,0-17.06,9.64-17.51,17.72Z" transform="translate(0 -290)"/><path fill="#e54b4d" d="M143.1,457.88a53.44,53.44,0,0,0,36-50.25c0-29.45-24.21-53.4-54-53.4s-54,23.95-54,53.4c0,25.06,17.56,46.07,41.13,51.79v5.24C85.8,458.85,66,435.56,66,407.63c0-32.3,26.47-58.49,59.12-58.49s59.12,26.19,59.12,58.49a58.54,58.54,0,0,1-41.13,55.68Zm-18-78.22a28.16,28.16,0,0,0-28.28,28,27.87,27.87,0,0,0,15.43,24.81v5.66a33.43,33.43,0,1,1,30.84-2.69v-6.32a27.68,27.68,0,0,0,10.29-21.46A28.16,28.16,0,0,0,125.11,379.66ZM30,407.63a93.69,93.69,0,0,0,43.28,78.83c1.58-1,3.19-2,4.82-2.9,1.17-.65,2.34-1.28,3.54-1.89q2.14-1.1,4.35-2.07c1.47-.66,3-1.27,4.45-1.85,1.23-.48,2.46-.92,3.71-1.35,1.74-.59,3.51-1.14,5.31-1.63,1.34-.38,2.7-.73,4.07-1s2.78-.62,4.2-.88,3-.54,4.53-.74c1.7-.18,3.41-.38,5.14-.52V415.26h-5.14V405.09H138v67a96.09,96.09,0,0,1,39,14.36,93.68,93.68,0,0,0,43.29-78.83c0-52-42.58-94.09-95.11-94.09S30,355.66,30,407.63Z" transform="translate(0 -290)"/><rect fill="none" width="800" height="220"/></svg>);

const Settings = (props: TSettingsProps) => {

                
    const { id: parentSettingsId, child: childSettingsId } = useParams<any>();
    const savedContext = getSavedContext();
    const scrollbarRef = useRef<any>(null);
    
    const [branches, setBranches] = useState<TDropdownOption[]>(null);
    const [currentPage, setCurrentPage] = useState<any>(null);
    const currentContext:any = savedContext;
    
    const [currentOneSignalId, setCurrentOneSignalId] = useState<any>(null);
    const [isPushNotificationsEnabled, setIsPushNotificationsEnabled] = useState<boolean>(false);
    const [isNotificationSoundEnabled, setNotificationSoundEnabled] = useState<boolean>(false);
    const [showTeamCount, setShowTeamCount] = useState<boolean>(false);

    const representativeSettings: TRepresentative[] = useSelector(representativeSettingsSelectors.selectAll);
    const currentUser  = representativeSettings[0];
    const region = (window.location.hostname.includes(".ca.")||window.location.hostname.includes("localhost")) ? "ca" : "us";
    const { t } = useTranslation();

    const handleOnScroll = () => { };

    const setBranchHandler = (branchList: any[]) => {
        const selectedList = [];
        props.userMetadata?.branch?.forEach(item => {
            const name = getBranchNames(branchList, item);
            if (name) {
                selectedList.push(name);
            }
        });
    };

    useEffect(() => {
        const soundEnabled = localStorage.getItem(TEXTKIT_NOTIFICATION_SOUND);
        if (soundEnabled === "true"){
            setNotificationSoundEnabled(true);
        } else {
            setNotificationSoundEnabled(false);
        }
    }, []);


    useEffect(() => {
        setCurrentPage(`${parentSettingsId}:${childSettingsId}`);

        if (currentPage === "personal:profile") {
            (async () => {
                const data = await getBranchesHandler();
                if (!branches) setBranches(data);
            })();
        }

        if (currentPage === "workspace:sources") {
        }

        if (currentPage === "personal:notifications") {
            setIsPushNotificationsEnabled(props.userMetadata?.notification ? props.userMetadata.notification : false);
        }
        
        if (currentPage === "personal:preferences") {
            setShowTeamCount(props.userMetadata?.teamConversationCount ? props.userMetadata.teamConversationCount : false);
        }
    }, [childSettingsId, currentPage]);

    useEffect(() => {
        if (currentPage === "personal:notifications") {
            if (props.updateMetadata && props.userMetadata.notification) {
                setIsPushNotificationsEnabled(props.userMetadata.notification)
                if (props.userMetadata.notification !== true ) {
                    OneSignal.showSlidedownPrompt();
                }
            }
        }
        if (currentPage === "personal:profile") {
            if (props.updateMetadata && props.userMetadata?.branch) {
                if(branches) setBranchHandler(branches);
            }
        }
        if (currentPage === "personal:preferences") {
            if (props.updateMetadata && props.userMetadata?.teamConversationCount) {
                setShowTeamCount(props.userMetadata.teamConversationCount)
            }
        }
    }, [props.userMetadata]);

    const onToggle = (value: SwitchValue) => {
        if (OneSignal) {
            const newUserMetadata = props.userMetadata;
            newUserMetadata["notification"] = value.on;

            OneSignal.setSubscription(value.on);
            setIsPushNotificationsEnabled(value.on);
            props.updateMetadata(newUserMetadata);
        }
    };
    
    const onNotificationSoundToggle = (value: SwitchValue) => {
        localStorage.setItem(TEXTKIT_NOTIFICATION_SOUND, String(value.on));
        setNotificationSoundEnabled(value.on);
    };

    const notificationSettings = () => {
        if (currentPage === "personal:notifications") {
            OneSignal.on("subscriptionChange", function(isSubscribed) {
                setIsPushNotificationsEnabled(isSubscribed);                    
            });
            OneSignal.setSubscription(props.userMetadata?.notification);
            OneSignal.setExternalUserId(currentUser?.participantId);
            OneSignal.getExternalUserId().then(function(externalUserId){
                setCurrentOneSignalId(externalUserId);
            });
            OneSignal.isPushNotificationsEnabled(function(isEnabled) {
                if (isEnabled) {
                    setIsPushNotificationsEnabled(true);
                } 
            });
        }
        
        return (
            <>
                <div className="c-settings__group">
                    {OneSignal ? (<>
                        <div className="c-settings__group__label">
                            {t("Enable Push Notifications")}
                        </div>
                        <div className="c-settings__group__option">
                            {currentOneSignalId ? <Switch 
                                id={"AVAILABILITY_SWITCH"}
                                onChange={onToggle} 
                                value={{on: isPushNotificationsEnabled}}
                            />:<>Notifications aren't available to your browser.</>}
                        </div>
                    </>) : (<>
                        <div className="c-settings__group__label">
                            {OneSignalLogo}
                        </div>
                        <div className="c-settings__group__option c-settings__group__option--left">
                            {t("Notifications are not enabled for your account. Contact your Success Manager to sign up for OneSignal.")}
                        </div>
                        
                    </>)}
                </div>
                <div className="c-settings__group">
                    <div className="c-settings__group__label">
                        {t("Play Sound On New Message")}
                    </div>
                    <div className="c-settings__group__option">
                        <Switch 
                            id={"PLAY_SOUND_SWITCH"}
                            onChange={onNotificationSoundToggle} 
                            value={{on: isNotificationSoundEnabled}}
                        />
                    </div>
                </div>
            </>
        );
    };

    const teamCountToggle  = (value: SwitchValue)=>{
        const newUserMetadata = props.userMetadata;
        newUserMetadata["teamConversationCount"] = value.on;
        props.updateMetadata(newUserMetadata);
        setShowTeamCount(value.on);
    }

    const ShowCountSettings = ({ showTeamCount }) => {
        return (
            <>
                <div className="c-settings__group">
                    <div className="c-settings__group__label">
                        {t("Show Team Conversation Count")}
                    </div>
                    <div className="c-settings__group__option">
                        {<Switch 
                            id={"SHOW_TEAM_COUNT"}
                            onChange={teamCountToggle} 
                            value={{on: showTeamCount}}
                        />}
                    </div>
                </div>
            </>
        );
    }

    const profileSettings = () => {
        
        return (<>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Your Login Identfier")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentUser.identifier}</span>
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Your Participant ID")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentUser.participantId}</span>
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Your Preferred Locale")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentUser.locale}</span>
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Your Timezone")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{props.userMetadata.timezone}</span>
                </div>
            </div>
        </>);
    };

    const developerSettings = () => {
        
        return (<>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Your Participant ID")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentUser.participantId}</span>
                </div>
            </div>        
            <div className="c-settings__group">
                <div className="c-settings__group__label">    
                    {t("Token Endpoint")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentContext?.tokenApiUrl ? currentContext.tokenApiUrl : `https://textkit-prod-${region}.us.auth0.com`}</span>
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("API Endpoint")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentContext?.apiUrl ? currentContext.apiUrl : `https://api.${region}.textkit.io`}</span>
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("API Location")}
                </div>
                <div className="c-settings__group__option">
                    {awsLogo} <span className="text">{region === "ca" ? "ca-central-1 (Canada)" : "us-east-1 (Virginia)"}</span>
                </div>
            </div>
            {currentContext?.partner?.id && <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Your Partner ID")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentContext.partner.id}</span>
                </div>
            </div>}
            {currentContext?.partner?.name && <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Your Integration Partner")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentContext.partner.name}</span>
                </div>
            </div>}
            {currentContext?.twilio && <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Twilio API Keys")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">AccountSid: {currentContext?.twilio?.accountSid}</span><br/>
                    <span className="text">MessagingSid: {currentContext?.twilio?.messagingSid}</span><br/>
                    <span className="text">ConversationsSid: {currentContext?.twilio?.ConversationsSid}</span>
                </div>
            </div>}
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Webhooks")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">0/999 webhooks configured</span>
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Embedded Apps")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">0/5 self-hosted apps configured</span>
                </div>
            </div>
            {currentContext?.vanityUrl && (<div className="c-settings__group">
                <div className="c-settings__group__label">
                    {t("Custom Domain")}
                </div>
                <div className="c-settings__group__option">
                    <span className="text">0 custom domains configured</span>
                </div>
            </div>)}
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    <div className="c-settings__logo">{RudderstackLogo}</div>
                    <div><small>{t("Data Plane URL")}</small></div>
                </div>
                <div className="c-settings__group__option">
                    <span className="text">No custom Data Plane configured</span>
                </div>
            </div>
            {currentContext?.oneSignal?.appId && (<div className="c-settings__group">
                <div className="c-settings__group__label">
                <div className="c-settings__logo">{OneSignalLogo}</div>
                    <div><small>{t("App ID")}</small></div>
                </div>
                <div className="c-settings__group__option">
                    <span className="text">{currentContext.oneSignal.appId}</span>
                </div>
            </div>)}
            
        </>);
    };

    const uploadSettings = () => {

        //@ts-ignore
        return (
            <>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    Upload a CSV
                </div>
                <div className="c-settings__group__option" dangerouslySetInnerHTML={{__html: `
                        <button class="c-settings-upload" onClick="Osmos.handleClick('pxcrbejt6cm4lflvn12shccou9agsya4efvkmpofrjtd0m43s')">
                        Upload Your Data
                        </button>`}}>
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    S3 Bucket
                </div>
                <div className="c-settings__group__option">
                    Not enabled
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    Kafka
                </div>
                <div className="c-settings__group__option">
                    Not enabled
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    Sanity.io
                </div>
                <div className="c-settings__group__option">
                    Not enabled
                </div>
            </div>
            <div className="c-settings__group">
                <div className="c-settings__group__label">
                    Contentful
                </div>
                <div className="c-settings__group__option">
                    Not enabled
                </div>
            </div>
            </>
            );
    };

    const renderScreen = () => {
        
        if (currentPage === "personal:notifications") {
            if (OneSignal && props.userMetadata && currentUser) {
                return notificationSettings();            
            }
        } else if (currentPage === "personal:profile") {
            if (props.userMetadata && currentUser) {
                return profileSettings();            
            }
        } else if (currentPage === "workspace:developers") {
            if (currentContext && props.userMetadata && currentUser) {
                return developerSettings();            
            }
        } else if (currentPage === "workspace:sources") {
            return uploadSettings();  
        } else if (currentPage === "personal:preferences"){
            return <ShowCountSettings showTeamCount={showTeamCount} />
        } else {
            if (!childSettingsId) {
                return null;
            }
            
            return <div className="c-settings__group">
                <span className="p-settings__label">This setting is managed by your integration partner.</span>
            </div>;
        }
        
    };

    return (
        <div className="p-settings">
            <Scrollbars ref={scrollbarRef} hideTracksWhenNotNeeded={true} onScroll={handleOnScroll}>
                <div className="c-settings">
                {childSettingsId ? (
                    <div className="c-settings__heading">
                        {t(childSettingsId)}
                    </div>
                ) : (
                    <>
                    <div className="c-settings__heading">
                        {t("Settings")}
                    </div>
                    <div className="c-settings__group">
                        <span>{t("Choose a setting on the left.")}</span>
                    </div>
                    </>
                )}
                    {renderScreen()}
                
            </div>
            </Scrollbars>
        </div>
    );
};

export default Settings;
